import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import OpeningHoursBar from "@/components/OpeningHoursBar";
import AnnouncementsSection from "@/components/AnnouncementsSection";
import FeaturesSection from "@/components/FeaturesSection";
import TestimonialSection from "@/components/TestimonialSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Kuntosali Takomo",
  "url": "https://www.kuntotakomo.fi",
  "telephone": "+358405738882",
  "email": "info@kuntotakomo.fi",
  "description": "Kaksi laadukasta kuntosalia Jokelassa ja Kellokoskella.",
  "address": [
    {
      "@type": "PostalAddress",
      "streetAddress": "Kievarintie 4",
      "addressLocality": "Jokela",
      "postalCode": "05400",
      "addressCountry": "FI"
    },
    {
      "@type": "PostalAddress",
      "streetAddress": "Marskilantie 1",
      "addressLocality": "Kellokoski",
      "postalCode": "04500",
      "addressCountry": "FI"
    }
  ],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "name": "Jokela",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    {
      "@type": "OpeningHoursSpecification",
      "name": "Kellokoski",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "05:00",
      "closes": "22:00"
    }
  ]
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Kuntosali Takomo — Kuntosalit Jokelassa ja Kellokoskella"
        description="Kaksi laadukasta kuntosalia Jokelassa ja Kellokoskella. Jokela avoinna 24/7, Kellokoski 05–22. Molempiin kulku samalla kortilla. Liity jäseneksi!"
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <OpeningHoursBar />
      <AnnouncementsSection />
      <FeaturesSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
